(function(arc, $) {
  arc.i18n = {
    messages: $i.i18n.messages
  };

  arc.i18n.get = function (key, args) {
    var message = arc.i18n.messages[key];
    if (message === undefined) {
      console.warn('Missing i18n message for key:', key);
      return key;
    }
    return args ? arc.i18n.format(message, args) : message;
  };

  arc.i18n.put = function (key, message) {
    arc.i18n.messages[key] = message;
  };

  arc.i18n.format = function(message, args) {
    if (!Array.isArray(args)) return message;
    var str = message;
    for (var i = 0; i < args.length; i++) {
      var reg = new RegExp("\\{" + i + "\\}", "gm");
      str = str.replace(reg, args[i]);
    }
    return str;
  };

})(arc, jQuery);